import { createServiceFactory } from '@/services/factory'
import { createMockPaymentService } from './payments.mock'
import { createHttpPaymentService } from './payments.http'

export type { PaymentService } from './payments.service'

export const getPaymentService = createServiceFactory(
  'payments',
  createMockPaymentService,
  createHttpPaymentService
)
